import { defineMessages } from 'react-intl';

const translations = {
  message: {
    id: 'pages.unpackingView.alreadyPlacedMessage.message',
    defaultMessage: 'This shipment has already been placed',
    description: 'Message of the shipment already placed message',
  },
  actions: {
    viewParcels: {
      id: 'actions.viewParcels',
      defaultMessage: 'View parcels',
      description: 'Label of the view parcels action of the already placed message',
    },
  },
};

export default defineMessages(translations);
